import { BigNumber } from '@ethersproject/bignumber';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';
import { useVaultSdk } from '@ui/utils/strategy';

export const useStrategyPriceImpact = (
  token: LiquidityStrategyDepositToken,
  amount: BigNumber,
  isWithdraw: boolean,
  options: UseQueryOptions<number | undefined> = {},
) => {
  const vaultSdk = useVaultSdk(token);

  return useQuery<number | undefined>(
    ['useStrategyPriceImpact', token, amount, isWithdraw],
    async () => {
      if (!vaultSdk) {
        return;
      }
      if (amount.eq(BigNumber.from(0))) return 0;

      const result = await (isWithdraw
        ? vaultSdk.getWithdrawPriceImpact(amount)
        : vaultSdk.getDepositPriceImpact(amount));

      return result;
    },
    options,
  );
};
